import { css } from 'styled-components';

import { media } from '../../lib/StyledComponents';

export interface IModalContent {
  leftAlign?: boolean;
  hideImage?: boolean;
  padding?: {
    mobile?: string;
    small?: string;
    medium?: string;
  };
}

export const modalContentStyles = css<IModalContent>`
  ${({ padding }) => `padding: ${padding && padding.mobile || '3em 1.5em'};`}

  ${({ padding }) => css`
    ${media.small`
      padding: ${padding && padding.small || '3em'};
    `}
  `}

  ${props => css`
    ${media.medium`
      padding: ${props.padding && props.padding.medium || props.theme.modal.padding};
    `}
  `}

  * {
    text-align: center;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${props => props.leftAlign && `
    *:not(button) {
      text-align: left;
    }
  `}
`;
